function _EMOTION_STRINGIFIED_CSS_ERROR__() {
  return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
import React from "react";
import PropTypes from "prop-types";
import { jsx as ___EmotionJSX } from "@emotion/core";
var _ref2 = process.env.NODE_ENV === "production" ? {
  name: "13o7eu2",
  styles: "display:block;"
} : {
  name: "13o7eu2",
  styles: "display:block;",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uLy4uL3NyYy9pY29ucy9oYW1idXJnZXIuanMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBTU0iLCJmaWxlIjoiLi4vLi4vLi4vc3JjL2ljb25zL2hhbWJ1cmdlci5qcyIsInNvdXJjZXNDb250ZW50IjpbImltcG9ydCBSZWFjdCBmcm9tIFwicmVhY3RcIjtcbmltcG9ydCBQcm9wVHlwZXMgZnJvbSBcInByb3AtdHlwZXNcIjtcblxuZnVuY3Rpb24gSGFtYnVyZ2VyKHsgc2l6ZSwgcHJpbWFyeUNvbG9yLCB0ZXN0SWQgfSkge1xuICByZXR1cm4gKFxuICAgIDxzdmdcbiAgICAgIGNzcz17e1xuICAgICAgICBkaXNwbGF5OiBcImJsb2NrXCIsXG4gICAgICB9fVxuICAgICAgd2lkdGg9e3NpemV9XG4gICAgICBoZWlnaHQ9e3NpemV9XG4gICAgICB2aWV3Qm94PVwiMCAwIDMyIDMyXCJcbiAgICAgIGZvY3VzYWJsZT1cImZhbHNlXCJcbiAgICAgIHJvbGU9XCJpbWdcIlxuICAgICAgYXJpYS1sYWJlbD1cIkhhbWJ1cmdlclwiXG4gICAgICBkYXRhLXRlc3RpZD17dGVzdElkfVxuICAgID5cbiAgICAgIDxwYXRoXG4gICAgICAgIGQ9XCJNMjYgMjJhMSAxIDAgMDEwIDJINmExIDEgMCAwMTAtMmgyMHptMC03YTEgMSAwIDAxMCAySDZhMSAxIDAgMDEwLTJoMjB6bTAtN2ExIDEgMCAwMTAgMkg2YTEgMSAwIDExMC0yaDIwelwiXG4gICAgICAgIGZpbGw9e3ByaW1hcnlDb2xvcn1cbiAgICAgIC8+XG4gICAgPC9zdmc+XG4gICk7XG59XG5cbkhhbWJ1cmdlci5wcm9wVHlwZXMgPSB7XG4gIHNpemU6IFByb3BUeXBlcy5zdHJpbmcuaXNSZXF1aXJlZCxcbiAgcHJpbWFyeUNvbG9yOiBQcm9wVHlwZXMuc3RyaW5nLmlzUmVxdWlyZWQsXG4gIHRlc3RJZDogUHJvcFR5cGVzLnN0cmluZyxcbn07XG5cbmV4cG9ydCBkZWZhdWx0IEhhbWJ1cmdlcjtcbiJdfQ== */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
};
function Hamburger(_ref) {
  var size = _ref.size,
    primaryColor = _ref.primaryColor,
    testId = _ref.testId;
  return ___EmotionJSX("svg", {
    css: _ref2,
    width: size,
    height: size,
    viewBox: "0 0 32 32",
    focusable: "false",
    role: "img",
    "aria-label": "Hamburger",
    "data-testid": testId
  }, ___EmotionJSX("path", {
    d: "M26 22a1 1 0 010 2H6a1 1 0 010-2h20zm0-7a1 1 0 010 2H6a1 1 0 010-2h20zm0-7a1 1 0 010 2H6a1 1 0 110-2h20z",
    fill: primaryColor
  }));
}
Hamburger.propTypes = {
  size: PropTypes.string.isRequired,
  primaryColor: PropTypes.string.isRequired,
  testId: PropTypes.string
};
export default Hamburger;